/**
 * Redux async actions (src/store/actions/meetingActions.js).
 *
 * This module defines Redux Toolkit thunks (createAsyncThunk) that call backend endpoints via the shared axios client.
 * Slices consume the fulfilled payloads in `extraReducers` to update the UI state.
 */

import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../helpers/axiosconfig";
// BUG-004/005: getStoredToken no longer needed - auth is via httpOnly cookie

/**
 * Async thunk: generateMeetingToken.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const generateMeetingToken = createAsyncThunk(
    "meeting/generateToken",
    async (roomId, { rejectWithValue }) => {
      try {
        // BUG-004/005: Auth token is in httpOnly cookie, sent automatically via withCredentials.
        const response = await axios.post('/generate-meeting-token',
          { roomId }
        );
        
        return response.data.token;
      } catch (error) {
        console.error('Error in generateMeetingToken:', error.response?.data || error.message);
        return rejectWithValue(error.response?.data || 'Failed to generate meeting token');
      }
    }
  );
